import { render, staticRenderFns } from "./LawyerAppointMatter.vue?vue&type=template&id=3c930e23&scoped=true&"
import script from "./LawyerAppointMatter.vue?vue&type=script&lang=js&"
export * from "./LawyerAppointMatter.vue?vue&type=script&lang=js&"
import style0 from "./LawyerAppointMatter.vue?vue&type=style&index=0&id=3c930e23&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c930e23",
  null
  
)

export default component.exports